import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Exam|Edit History|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPExamCatalogEditHistory';
export type SPExamCatalogEditHistoryLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}ContentNoHistory`;

export const spExamCatalogEditHistoryLocs: LocDefs<SPExamCatalogEditHistoryLocNames> = {
	SPExamCatalogEditHistoryTitlePage: {
		defaultValue: 'Exam Catalog Edit History',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Exam/Catalogs.Exams.EditHistory.Title.PageTitle',
		...sharedProperties,
	},
	SPExamCatalogEditHistoryContentNoHistory: {
		defaultValue: 'No history',
		description: 'Message displayed when there is no history',
		displayPath: `${pathStart}No history`,
		displayType: 'Content',
		legacyName: 'Exam/Catalogs.Exams.EditHistory.Content.NoHistory',
		...sharedProperties,
	},
};

export type SPExamCatalogEditHistoryLocType = LocMap<SPExamCatalogEditHistoryLocNames>;
